

export const get_menus = async () =>{
    let res = await request.get('/data/menus.json');
    return res.data;
}